module.exports = __webpack_public_path__ + "media/images/categories/headers/finance-and-money-404302ef8f03afab0fbad0684d897b04.jpg";